import React from "react";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from "@mui/material";
import { ArrowUpward, ArrowDownward } from "@mui/icons-material";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";


const ProductTable = ({ products }) => {

    const formatCurrency = (value) => {
        return new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL"
        }).format(value);
    };
    return (
        <TableContainer component={Paper} sx={{ minWidth: 800, boxShadow: 3, borderRadius: 2, maxHeight: '100%' }}>
            <Table stickyHeader>
                <TableHead>
                    <TableRow
                        sx={{
                            "& th": {
                                backgroundColor: "#424242",
                                color: "#fff",
                                fontWeight: "bold",
                            },
                        }}
                    >
                        <TableCell>Data</TableCell>
                        <TableCell>ID Produto</TableCell>
                        <TableCell>Modelo</TableCell>
                        <TableCell>Movimento</TableCell>
                        <TableCell>Qtd Movida</TableCell>
                        <TableCell>Preço de Venda</TableCell>
                        <TableCell>Observação</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {products.sort((b, a) => new Date(a.criados) - new Date(b.criados)).map((product, index) => (
                        <TableRow
                            key={product.id}
                            sx={{
                                backgroundColor: index % 2 === 0 ? "#ffffff" : "#f2f2f2", // branco / cinza claro
                                "&:hover": { backgroundColor: "#e6f2ff" },
                                "& td": { color: "#333" }, // força cor do texto
                            }}
                        >
                            <TableCell>{dayjs(product.criados).format("DD/MM/YYYY")}</TableCell>
                            <TableCell>{product.product_id}</TableCell>
                            <TableCell>{product.model}</TableCell>
                            <TableCell>
                                <Box display="flex" alignItems="center">
                                    {product.type_move === "entrada" ? (
                                        <ArrowDownward sx={{ color: "green" }} />
                                    ) : (
                                        <ArrowUpward sx={{ color: "red" }} />
                                    )}
                                    <Typography ml={1}>{product.type_move === 'entrada' ? 'Entrada' : "Saída"}</Typography>
                                </Box>
                            </TableCell>
                            <TableCell>{product.quantity_moved}</TableCell>
                            <TableCell>{formatCurrency(product.sell_price)}</TableCell>
                            <TableCell>{product.observation || "-"}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default ProductTable;
